import { emptyAccount, IAccount } from "components/account/IAccount";

export interface IWalletState {
  accounts: IAccount[];
  current: IAccount;
}

const initialState: IWalletState = {
  accounts: [emptyAccount],
  current: emptyAccount,
};

interface IAction {
  type: string;
  payload: any;
}

// Use the initialState as a default value
const walletReducer = (state: IWalletState = initialState, action: IAction) => {
  // The reducer normally looks at the action type field to decide what happens
  switch (action.type) {
    // Do something here based on the different types of actions
    case "change_current": {
      // We need to return a new state object
      return {
        // that has all the existing state data
        ...state,
        // but has a new array for the `todos` field
        current: action.payload,
      };
    };
    // Do something here based on the different types of actions
    case "account_subscribers": {
      // We need to return a new state object
      return {
        // that has all the existing state data
        ...state,
        // but has a new array for the `todos` field
        subs: action.payload,
      };
    };
    default:
      // If this reducer doesn't recognize the action type, or doesn't
      // care about this specific action, return the existing state unchanged
      return state;
  }
};

export default walletReducer;